<template>
	<div class="row d-flex justify-content-center text-center m-1">
		<div class="col-12">
			<span class="font-weight-bold">{{ obj.nev }}</span>
			<span class="h5" v-if="obj.cegnev != ''">({{ obj.cegnev }})</span>
			<span class="h5" v-if="obj.cegnev === ''">(Magánszemély)</span>
		</div>

		<div class="col-12 col-md-6">
			<div class="row d-flex m-1">
				<div class="col-12">
					<div class="row d-flex mb-1">
						<div class="col-12">
							<span class="h5">Adatok</span>
						</div>
					</div>
					<div class="row border-top border-left border-right">
						<div class="col-6">
							Automata
							<input type="checkbox" disabled :checked="obj.automataa === 1">
							</div>
						<div class="col-6">
							Szerződés
							<input type="checkbox" disabled :checked="obj.automata_szerzodes === 1">
						</div>
					</div>
					<div class="row border-top border-left border-right">
		                <div class="col-4 text-left">
		                  	Kategória
		                </div>
		                <div class="col-8 text-left">
		                  	{{obj.kat}}
		                </div>
		            </div>
		            <div class="row border-top border-left border-right">
			            <div class="col-4 text-left">
			              	Cím
			            </div>
			            <div class="col-8 text-left">
			              	{{obj.varos}} - {{obj.cim}}
			            </div>
			        </div>
			        <div class="row border-top border-left border-right">
		                <div class="col-4 text-left">
		                  	Dátum limit
		                </div>
		                <div
		                	class="col-8 text-left"
		                	:class="[obj.datum_limit == '' ? 'bg-warning' : '']"
		                >
		                	<span v-if="obj.datum_limit != ''">
		                		{{obj.datum_limit}} nap	
		                	</span>
		                  	<span v-if="obj.datum_limit == ''">
		                  		Nincs beállítva dátum limit
		                  	</span>
		                </div>
		            </div>
		            <div class="row border-top border-left border-right">
		                <div class="col-4 text-left">
		                  Minimum rendelési összeg
		                </div>
		                <div
		                	class="col-8 text-left"
		                	:class="[obj.min == '' ? 'bg-warning' : '']"
		                >
		                	<span v-if="obj.min !== ''">
		                		{{obj.min | huf}} Ft		
		                	</span>
		                  	<span v-if="obj.min === ''">
		                  		Nincs beállítva összeg		
		                  	</span>
		                </div>
		            </div>
		            <div class="row border-top border-left border-right">
		                <div class="col-4 text-left">
		                  	Telefon 1
		                </div>
		                <div
		                	class="col-8 text-left"
		                	:class="[obj.telm == '' ? 'bg-warning' : '']"
		                >
		                  	<span v-if="obj.telm != ''">
		                  		{{ obj.telm | tel }}
		                  	</span>
		                  	<span v-if="obj.telm == ''">
		                  		Nincs telefonszám
		                  	</span>
		                </div>
		            </div>
		            <div class="row border-top border-left border-right">
		                <div class="col-4 text-left">
		                  	Telefon 2
		                </div>
		                <div
		                	class="col-8 text-left"
		                	:class="[obj.telv == '' ? 'bg-warning' : '']"
		                >
		                  	<span v-if="obj.telv != ''">
		                  		{{ obj.telv | tel }}
		                  	</span>
		                  	<span v-if="obj.telm == ''">
		                  		Nincs telefonszám
		                  	</span>
		                </div>
		            </div>
		            <div class="row border">
		                <div class="col-4 text-left">
		                  E-mail cím
		                </div>
		                <div
		                	class="col-8 text-left"
		                	:class="[obj.email == '' ? 'bg-warning' : '']"
		                >
		                	<span v-if="obj.email != ''">
		                		{{obj.email}}		
		                	</span>
		                	<span v-if="obj.email == ''">
		                		Nincs e-mail cím
		                	</span>
		                  
		                </div>
		            </div>
				</div>
			</div>
		</div>

		<div class="col-12 col-md-6">
			<div class="row d-flex m-1">
				<div class="col-12 mb-1">
					<span class="h5">Utolsó lezárt rendelés</span>
				</div>
              	<div class="col-6 border-top border-left">
              		Lezárás időpontja:
              		{{ obj.urend | date}}
              	</div>
              	<div class="col-6 border-top border-right">
              		Limit óta eltelt: {{ obj.day }} nap
              	</div>
              	<div class="col-6 border-top border-left">
              		Sorszáma:
              		{{ obj.rendelesszam }}
              	</div>
              	<div class="col-6 border-top border-right">
              		Összege:
              		{{ obj.osszeg | huf }} Ft
              	</div>
              	<!--<div class="col-12 h5 border-top pt-2">
              		Rendelés részletei
              	</div>-->
              	<div
              		class="col-12"
              		v-for="(v,k) in obj.list"
              		:key="`${k}-${obj.uszam}`"
              	>
              		<div class="row border">
              			<div class="col-6">
              				{{v.tetel}}
                  		</div>
                  		<div class="col-3">
                  			{{v.db}} db
                  		</div>
                  		<div class="col-3">
                  			{{v.ar | huf}} Ft
                  		</div>
              		</div>
              	</div>
			</div>

			<div class="row d-flex m-1" v-if="obj.hasopenorder == 'true'">
				<div class="col-12 mb-1 mt-2">
					<span class="h5">Utolsó nyitott rendelés</span>
				</div>
              	<div class="col-12 border-top border-left">
              		Rögzítés időpontja:
              		{{ obj.datumaktiv | date}}
              	</div>
              	<!--<div class="col-6 border-top border-right">
              		Limit óta eltelt: {{ obj.oldday }} nap
              	</div>-->
              	<div class="col-6 border-top border-left">
              		Sorszáma:
              		{{ obj.rendelesszamaktiv }}
              	</div>
              	<div class="col-6 border-top border-right">
              		Összege:
              		{{ obj.osszegaktiv | huf }} Ft
              	</div>
              	<div
              		class="col-12"
              		v-for="(v,k) in obj.listaktiv"
              		:key="`${k}-${obj.uszam}-old`"
              	>
              		<div class="row border">
              			<div class="col-6">
              				{{v.tetel}}
                  		</div>
                  		<div class="col-3">
                  			{{v.db}} db
                  		</div>
                  		<div class="col-3">
                  			{{v.ar | huf}} Ft
                  		</div>
              		</div>
              	</div>
			</div>

			<div class="row d-flex m-1" v-else>
				<div class="col-12 mt-2">
					<span class="h5">
						Nincs nyitott rendelés
					</span>
				</div>
			</div>

		</div>

		<div class="col-12 mt-2" v-if="obj.megj != ''">
			<div class="row justify-content-center m-1">
                <div class="col-12 text-center">
                  	<h5>
                    	Megjegyzés
                  	</h5>
                </div>
                <div class="col-12 border">
                  	<div class="text-center m-2">
                    	{{obj.megj}}
                  	</div>
                </div>
            </div>
		</div>

		<div class="col-12">
			<div class="row justify-content-center m-2">
            	<button
	          		class="btn btn-outline-primary m-1"
	          		@click.prevent="neworder(obj.id)"
	        	>
	          		Új rendelés indítása
	        	</button>
            	<router-link
                	:to="`/customer/${obj.id}`" target="_blank"
            	>
                	<button class="btn btn-outline-primary m-1">
                    	Ügyfél módosítás
                	</button>
            	</router-link>
              	<order-history
                	class="m-1"
                	:id="obj.uszam"
              	>
              </order-history>
          	</div>
          	<div class="row justify-content-center">
              	<div class="divider text-center w-75"></div>
            </div>
		</div>

	</div>
</template>

<script type="text/javascript">
import { mapActions } from 'vuex'

export default {
	props: ['obj'],

	data() {
		return {

		}
	},

	methods: {
		...mapActions(['setrendselcustomer']),

		neworder(id){
			var item = {}
			this.$Progress.start()
          	//this.isLoading = true
          	this.req.post(`/customers/search`,{
              	search: {id: id},
              	order: `nev`,
              	order_dir: false
          	})
              	.then(res => {
                  	item = res.data.customers[0]
                  	this.setrendselcustomer(item)
          			window.open(this.$router.resolve({ path: '/orders/new_order/products' }).href, '_blank')
                  	this.$Progress.finish()
                  	//this.isLoading = false
              	})
              	.catch(err => {
                	console.log(err)
                	this.$Progress.fail()
                	//this.isLoading = false
             	})
      	},
	}
}
</script>

<style type="text/css" scoped>
.divider {
  	border: 1px solid black;
  	margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/stats/kimikorItem.vue